var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Archives.less');

var ArchivesBooks = require('front/components/ArchivesBooks/ArchivesBooks');
var ArchivesCollections = require('front/components/ArchivesCollections/ArchivesCollections');
var CommonGallery = require('front/components/CommonGallery/CommonGallery');
var ArchivesInfo = require('front/components/ArchivesInfo/ArchivesInfo');

module.exports = Section.extend({

    el: '.Archives',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'ArchivesBooks': {selector: '.ArchivesBooks', viewConstructor: ArchivesBooks},
        'ArchivesCollections': {selector: '.ArchivesCollections', viewConstructor: ArchivesCollections},
        'CommonGallery': {selector: '.CommonGallery', viewConstructor: CommonGallery},
        'ArchivesInfo': {selector: '.ArchivesInfo', viewConstructor: ArchivesInfo}
    },

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Archives/Archives.js
// module id = 245
// module chunks = 0